'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var _createClass = require('@babel/runtime/helpers/createClass');
var _classCallCheck = require('@babel/runtime/helpers/classCallCheck');
var _inherits = require('@babel/runtime/helpers/inherits');
var _createSuper = require('@babel/runtime/helpers/createSuper');
var _wrapNativeSuper = require('@babel/runtime/helpers/wrapNativeSuper');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var _createClass__default = /*#__PURE__*/_interopDefaultLegacy(_createClass);
var _classCallCheck__default = /*#__PURE__*/_interopDefaultLegacy(_classCallCheck);
var _inherits__default = /*#__PURE__*/_interopDefaultLegacy(_inherits);
var _createSuper__default = /*#__PURE__*/_interopDefaultLegacy(_createSuper);
var _wrapNativeSuper__default = /*#__PURE__*/_interopDefaultLegacy(_wrapNativeSuper);

var ReconcileApiExceptionType = /*#__PURE__*/function (ReconcileApiExceptionType) {
  ReconcileApiExceptionType["EmailAlreadyUsed"] = "https://api.landr.com/errors/EmailAlreadyUsed";
  return ReconcileApiExceptionType;
}({});
var AuthServiceCustomErrors = /*#__PURE__*/function (AuthServiceCustomErrors) {
  AuthServiceCustomErrors["ReconcileError"] = "reconcile_error";
  AuthServiceCustomErrors["CodeAndStateValidationError"] = "code_and_state_validation_error";
  AuthServiceCustomErrors["EmailAlreadyUsedError"] = "email_already_used_error";
  AuthServiceCustomErrors["AccessTokenRequestError"] = "access_token_request_error";
  return AuthServiceCustomErrors;
}({});
var OAuthError = /*#__PURE__*/function (_Error) {
  _inherits__default["default"](OAuthError, _Error);
  var _super = _createSuper__default["default"](OAuthError);
  function OAuthError(message, errorCode) {
    var _this;
    _classCallCheck__default["default"](this, OAuthError);
    _this = _super.call(this, message);
    _this.errorCode = errorCode;
    return _this;
  }
  return _createClass__default["default"](OAuthError);
}( /*#__PURE__*/_wrapNativeSuper__default["default"](Error));

exports.AuthServiceCustomErrors = AuthServiceCustomErrors;
exports.OAuthError = OAuthError;
exports.ReconcileApiExceptionType = ReconcileApiExceptionType;
